module.exports = __webpack_public_path__ + "images/howtouse/howto-functions01_d8b79696edf1415ec77c03f307a9d7fc.png";